export default t => (isScore, schema) => (isScore ? schema.required(t("field_is_required")).nullable() : schema.nullable());
